import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import FunctionGeneral from '../../functionsGeneral';

function ModalAsignacion(props) {
    const [vencimientSelect] = useState(props.listSelectVencimiento);
    const [optListaEmpleadosAsignacion, setOptListaEmpleadosAsignacion] =
        useState([]);
    useEffect(() => {
        var newlistopt = [];
        props.listPerfilesAsignacionVolumenVendedor.forEach(element => {
            newlistopt.push(
                <option
                    value={element.IDEMPLEADO}
                    key={element.CODEMPLEADO + element.PERFIL}
                >
                    {element.NOMBRE !== null
                        ? new FunctionGeneral().capitalizeText(
                              element.NOMBRE.split(' ')
                          ) /*+
                          ' ( ' +
                          element.IDEMPLEADO +
                          ' )'*/
                        : ''}
                </option>
            );
        });
        setOptListaEmpleadosAsignacion(newlistopt);
    }, [props.listPerfilesAsignacionVolumenVendedor]);

    function aplicarAsignacion() {
        props.aplicarAsignacionVencimiento(
            document.getElementById('selectVendedorAsignacion').value
        );
        props.setModalAsignacion(false);
    }
    return (
        <div className="c-modal">
            <div
                className="c-modal__overlay js-modal-close"
                onClick={() => props.setModalAsignacion(false)}
            ></div>
            <div
                className="c-modal__wrapper modalPosition_Asignacion"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header
                    className="c-modal__header"
                    style={{
                        padding: '0px',
                        paddingTop: '10px',
                    }}
                >
                    <div className="o-layout__item u-10/12 ">
                        <label className=" c-modal__title">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22.787"
                                height="25.8922"
                                viewBox="0 0 25.887 25.922"
                            >
                                <g
                                    id="Grupo_9058"
                                    data-name="Grupo 9058"
                                    transform="translate(-323.789 -612.767)"
                                >
                                    <path
                                        id="Combined-Shape"
                                        d="M15.61,0a.732.732,0,0,1,.732.732V3.415a.732.732,0,0,1-.732.732h-2.2V9.511h.855A3.293,3.293,0,0,1,17.561,12.8v2.561a.732.732,0,0,1-.732.732H.732A.732.732,0,0,1,0,15.366V12.8A3.293,3.293,0,0,1,3.293,9.512H3.9V4.146H1.463a.732.732,0,0,1-.732-.732V.732A.732.732,0,0,1,1.463,0Z"
                                        transform="translate(334.975 613.822) rotate(39)"
                                        fill="none"
                                        stroke="#004666"
                                        strokeWidth="1.5"
                                        fillRule="evenodd"
                                    />
                                    <path
                                        id="Rectangle"
                                        d="M2.2.2V7.094a1.1,1.1,0,0,1-2.2,0V0H0Z"
                                        transform="translate(331.153 630.941) rotate(39)"
                                        fill="#004666"
                                        fillRule="evenodd"
                                    />
                                </g>
                            </svg>
                            <span className="mideltextfilter u-text-brand">
                                Asignar
                            </span>
                        </label>
                    </div>

                    <div className="o-layout__item u-2/12">
                        <button
                            onClick={() => props.setModalAsignacion(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                        />
                    </div>
                </header>
                <div
                    className="c-modal__content u-mt-xsmall u-pb-small"
                    role="document"
                >
                    <div className="u-text-left u-10/12 u-mb">
                        <p>
                            Tienes{' '}
                            <span className="u-text-brand">
                                {vencimientSelect.length} vencimientos
                                selecionados.
                            </span>{' '}
                        </p>
                        <p>
                            Recuerda que si estos vencimientos ya están
                            asignados a alguien, se reasignarán automáticamente
                            al nuevo asesor seleccionado.
                        </p>
                    </div>

                    <div className="c-form-field__box u-pb-large">
                        <p className="u-text-left">Selecciona Asesor</p>
                        <div className="c-input c-input--select u-10/12">
                            <select
                                className="c-input__input"
                                id="selectVendedorAsignacion"
                            >
                                {optListaEmpleadosAsignacion}
                            </select>
                        </div>
                    </div>

                    <div className="o-split u-pt-large u-pb-small">
                        <button
                            className="c-btn c-btn--secondary"
                            style={{ width: '45%' }}
                            onClick={() => props.setModalAsignacion(false)}
                        >
                            CANCELAR
                        </button>
                        <button
                            className="c-btn"
                            style={{ width: '45%' }}
                            onClick={() => aplicarAsignacion()}
                        >
                            ASIGNAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(ModalAsignacion);
